/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Sub header api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
// import * as homeService from '../../services/home';

const subHeaderModel = {
  subHeaderVisible: false,
  heading: '',
  setSubHeaderVisibility: action((state, val) => {
    state.subHeaderVisible = val;
  }),
  setSubHeader: thunk(async (actions, val) => {
    actions.setSubHeaderVisibility(val);
  }),
};

export default subHeaderModel;
